import { gql } from "@apollo/client";

export const GET_PRODUCTS = gql`
  query GetProducts($user_id: UUID, $limit: Int, $offset: Int) {
    productsCollection(first: $limit, offset: $offset) {
      edges {
        node {
          id
          title
          price
          description
          category_id
          user_id
          users {
            id
            user_name
          }
          created_at
          updated_at
          image_urls
          product_type_id
          sale_price
          size
          color
          stock_quantity
          sku_number
          wishlist: wishlistCollection(
            filter: {
              is_deleted: {
                eq: false
              }
              user_id: {
                eq: $user_id
              }
            }
          ) {
            edges {
              node {
                id
                user_id
                product_id
                is_deleted
              }
            }
          }
        }
      }
    }
  }
`;
